<template>
    <default-modal ref="box"
        :title="title"
        :modalWidth="600"
        :confirmTxt="confirmText"
        @confirm="confirm">
        <div class=modal-body>
            <div>
                <div class=row>
                    <span class=left>服务器标签名：</span>
                    <input type="text"
                            v-model="labelName"
                            placeholder="长度最多16个字符，支持中英文">
                </div>
            </div>
        </div>
    </default-modal>
</template>
<script>
import DefaultModal from "_c/modals/defaultModal"

import {
    editLabelName
} from '@/requests/bar'
export default {
    components: {
        DefaultModal
    },
    data() {
        return {
            labelId: '',
            labelName: "",
            title:'',
            confirmText:"",
            successFn: ''
        }
    },
    mounted() {
        window.$modal.editServerLabel = {}
        window.$modal.editServerLabel.show = (labelId,labelName) => {
            if(labelId!==undefined){
               this.title='修改服务器标签名'
               this.labelId = labelId;
               this.labelName = labelName;
               this.confirmText = '保存'
            }else{
                this.title='添加标签';
                this.labelId = '';
                this.labelName = '';
                this.confirmText = '添加'
            }
            return new Promise((resolve)=>{
                this.init(()=>{
                    resolve(true)
                })
            })
        }
    },
    methods: {
        // 初始化信息
        init(fn) {
           this.$refs.box.show()
           this.successFn = fn
        },
        async confirm() {
            let vdt = this.$validateCenter.labelName(this.labelName)
            if (!vdt.res) {
                return this.$refs.box.setWrong(vdt.msg)
            }
            let resValue = await editLabelName({
                labelId: this.labelId,
                labelName:this.labelName
            })
            if(resValue.code==200){
                this.$refs.box.hide()
                this.successFn()
            }else{
                this.$refs.box.setWrong(resValue.msg)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import "_style/_color.scss";

.modal-body {
    padding: 10px;
    padding-left: 30px;
    padding-right: 30px;
    text-align: left;
    .row{
        height: 30px;
        line-height: 30px;
        overflow: hidden;
        margin:10px 0 30px 60px;
        .left{
            float:left;
            color: #A1A1A1;
            margin-right:10px;
            min-width:85px;
            display: inline-block;
            text-align: right;
            height: 30px;
            line-height: 30px;
        }
    }
    input {
        width: 250px;
        height: 30px;
        // background-color: rgba(242, 242, 242, 1);
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        border-color: rgba(230, 230, 230, 1);
        border-radius: 0px;
        font-size: 12px;
        color: #515151;
        text-align: left;
        padding-left:10px;
    }
}
</style>
